import { render, staticRenderFns } from "./FinancialReferralPriceTable.vue?vue&type=template&id=2a872655&"
import script from "./FinancialReferralPriceTable.vue?vue&type=script&lang=js&"
export * from "./FinancialReferralPriceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports